import React from 'react'
import ButtonModelUnit from './ButtonModelUnit'
import { PDFDownloadLink } from '@react-pdf/renderer'
import PDFDTemplates from './PDFGeneratorButtonComps/PDFDTemplates'
import i18next from 'i18next'

const PDFGeneratorButton = ({ button, element, isDarkModeActive }) => {
  const { type, fileName } = button.PDFGenProps
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <PDFDownloadLink
      document={
        PDFDTemplates({ button }).filter((temp) => temp.hashTagType === type)[0]
          .comp
      }
      fileName={fileName}
      style={{ width: '100%' }}
    >
      {({ loading }) =>
        loading ? (
          <ButtonModelUnit
            button={{
              ...button,
              title: rtl ? 'جارى تحضير ملف الـ PDF' : 'Preparing PDF',
              disabled: true,
            }}
            isDarkModeActive={isDarkModeActive}
            element={element}
          />
        ) : (
          <ButtonModelUnit
            button={{ ...button, title: rtl ? 'تحميل' : 'Download' }}
            isDarkModeActive={isDarkModeActive}
            element={element}
          />
        )
      }
    </PDFDownloadLink>
  )
}

export default PDFGeneratorButton
